import { LogoutRounded } from "@mui/icons-material";
import { Box, Button, CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";

interface LogoutConfirmDialogProps {
  open: boolean;
  isLoggingOut?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function LogoutConfirmDialog({
  open,
  isLoggingOut = false,
  onClose,
  onConfirm,
}: LogoutConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={() => !isLoggingOut && onClose()} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogContent sx={{ width: 400, maxWidth: "90vw", p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: purpleLight,
            mb: 2,
          }}
        >
          <LogoutRounded sx={{ color: purple, fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
          Log out?
        </Typography>
        <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
          You'll need to sign in again to access your account.
        </Typography>

        <Box display="flex" gap={1.5} width="100%" mt={4}>
          <Button
            fullWidth
            disabled={isLoggingOut}
            onClick={onClose}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            disabled={isLoggingOut}
            onClick={onConfirm}
            variant="contained"
            disableElevation
            startIcon={isLoggingOut ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <LogoutRounded sx={{ fontSize: 18 }} />}
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            {isLoggingOut ? "Logging out..." : "Logout"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
